<template>
    <div>
        <h1 id="title">Analytics</h1>
        <div id="cardsContainer">
            <b-card class="analyticsCard shadow">
                <h4><strong>Site's visits</strong></h4>
                <canvas id="visitsChart"></canvas>
            </b-card>

            <b-card class="analyticsCard shadow">
                <h4><strong>Clicks to Amazon link</strong></h4>
                <canvas id="amazonChart"></canvas>
            </b-card>

            <b-card class="analyticsCard shadow">
                <h4><strong>Earnings</strong></h4>
                <canvas id="earningsChart"></canvas>
            </b-card>

            <b-card class="analyticsCard shadow">
                <h4><strong>Totals Report</strong></h4>
                <div id="reportContainer">
                    <!-- This period -->
                    <div class="periodDiv">
                        <h5>Actual period</h5>
                        <ul>
                            <li><strong>Earnings: </strong>$400</li>
                            <li><strong>PC-Chooser Visitors: </strong>17</li>
                            <li><strong>Blog Visitors: </strong>115</li>
                            <li><strong>Visitors: </strong>122</li>
                            <li><strong>Amazon Link Clicks: </strong>122</li>
                        </ul>
                    </div>

                    <!-- Previous period -->
                    <div class="periodDiv">
                        <h5>Actual period</h5>
                        <ul>
                            <li><strong>Earnings: </strong>$400</li>
                            <li><strong>PC-Chooser Visitors: </strong>17</li>
                            <li><strong>Blog Visitors: </strong>115</li>
                            <li><strong>Visitors: </strong>122</li>
                            <li><strong>Amazon Link Clicks: </strong>122</li>
                        </ul>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Analytics',
    mounted() {
        let opt = {
            legend: {
                labels: {
                    fontSize: 13
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        fontSize: 15
                    }
                }],
                xAxes: [{
                    ticks: {
                        fontSize: 15
                    }
                }]
            }
        }

        // Charts
        var visitsChrt = document.getElementById('visitsChart').getContext('2d');
        var amazonChrt = document.getElementById('amazonChart').getContext('2d');
        var earningsChrt = document.getElementById('earningsChart').getContext('2d');
        var visitsChart = new Chart(visitsChrt, {
            type: 'line',
            data: {
                labels: ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'],
                datasets: [
                    {
                        label: 'Actual period',
                        data: [12, 19, 3, 5, 2, 3, 6],
                        backgroundColor: 'rgba(0, 170, 0, 0.15)',
                        borderColor: 'rgba(0, 100, 50, 0.75)',
                        borderWidth: 2
                    },
                    {
                        label: 'Previus period',
                        data: [4, 6, 8, 2, 5, 1, 2],
                        backgroundColor: 'rgba(170, 0, 0, 0.15)',
                        borderColor: 'rgba(0, 30, 100, 0.75)',
                        borderWidth: 2
                    }
                ]
            },
            options: opt
        });
        var amazonChart = new Chart(amazonChrt, {
            type: 'line',
            data: {
                labels: ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'],
                datasets: [
                    {
                        label: 'Actual period',
                        data: [2, 4, 0, 0, 1, 2, 2],
                        backgroundColor: 'rgba(71, 192, 75, 0.15)',
                        borderColor: 'rgba(71, 192, 75, 0.75)',
                        borderWidth: 2
                    },
                    {
                        label: 'Previus period',
                        data: [2, 6, 1, 0, 3, 1, 4],
                        backgroundColor: 'rgba(230, 165, 35, 0.15)',
                        borderColor: 'rgba(230, 165, 35, 0.75)',
                        borderWidth: 2
                    }
                ]
            },
            options: opt
        });
        var earningsChart = new Chart(earningsChrt, {
            type: 'line',
            data: {
                labels: ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'],
                datasets: [
                    {
                        label: 'Actual period',
                        data: [200, 30, 17, 318, 15, 0, 0],
                        backgroundColor: 'rgba(71, 192, 75, 0.15)',
                        borderColor: 'rgba(71, 192, 75, 0.75)',
                        borderWidth: 2
                    },
                    {
                        label: 'Previus period',
                        data: [0, 0, 26, 4, 140, 70, 66],
                        backgroundColor: 'rgba(209, 41, 74, 0.15)',
                        borderColor: 'rgba(209, 41, 74, 0.75)',
                        borderWidth: 2
                    }
                ]
            },
            options: opt
        });
    }
}
</script>

<style scoped>
.analyticsCard {
    max-width: 90vw;
    margin-left: auto;
    margin-right: auto;
    margin-top: 3vh;
}

#visitsChart {
    width: 400;
    height: 400;
}

#title {
    margin-left: 7vw;
    margin-top: 5vw;
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}

#cardsContainer {
    margin-bottom: 5vw;
}

@media screen and (min-width: 600px){
    .analyticsCard {
        width: 45vw;
    }
    
    #cardsContainer {
        display: flex;
        flex-wrap: wrap;
    }

    #reportContainer {
        display: flex;
        flex-flow: row;
        font-size: 1.1rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Analytics.vue